export default "__VITE_ASSET__Cjfc0k$H__"